export default __webpack_public_path__ + "static/media/EducationJobs.a60fc82109df56688e82e084854b8d0d.webp";